import { useEffect, useState } from "react";
import "@/App.css";
import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { getProducts } from "./lib/api";
import Navbar from "./components/site/Navbar";
import Hero from "./components/site/Hero";
import EditorialMarquee from "./components/site/EditorialMarquee";
import Store from "./components/site/Store";
import Manifesto from "./components/site/Manifesto";
import WinnerSpotlight from "./components/site/WinnerSpotlight";
import Footer from "./components/site/Footer";
import CartDrawer from "./components/site/CartDrawer";
import AdminDashboard from "./components/site/AdminDashboard";
import { PaymentSuccess, PaymentCancel } from "./components/site/PaymentPages";
import ThankYou from "./components/site/ThankYou";

const Home = () => {
  const [products, setProducts] = useState([]);
  const { hash } = useLocation();

  useEffect(() => {
    getProducts().then(setProducts).catch(() => {});
  }, []);

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
      }, 400);
    }
  }, [hash]);

  return (
    <>
      <Navbar />
      <CartDrawer />
      <main className="bg-[#ECECE8]">
        <Hero />
        <EditorialMarquee />
        <Store products={products} />
        <Manifesto />
        <WinnerSpotlight />
        <Footer />
      </main>
    </>
  );
};

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <CartProvider>
        <div className="noise-overlay" />
        <Toaster
          position="bottom-right"
          theme="light"
          toastOptions={{
            style: { background: "#FAF9F5", border: "1px solid #111111", color: "#111111" },
          }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/thankyou" element={<ThankYou />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </ReactLenis>
  );
}

export default App;
